import React from 'react';

interface CharacterCounterProps {
    currentLength: number;
    maxLength: number;
    className?: string;
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({ currentLength, maxLength, className }) => {
    const isOverLimit = currentLength > maxLength;
    return (
        <div className={`${className ? className : ''} text-sm ${isOverLimit ? 'text-red-500' : 'text-gray-500'}`}>
            {currentLength}/{maxLength}
        </div>
    );
};

export default CharacterCounter;